import { PersonUtilityData } from '@tymbe/schema/person-utility.interface';
import { FormState } from 'informed';
import { useState } from 'react';
import Modal from 'react-modal';
import { useMutation, useQueryClient } from 'react-query';

import PersonUtilityForm from './PersonUtilityForm';
import apiClient from '../../../../../apiClient';
import { defaultOnError } from '../../../../../apiClient/utils';
import { IconButton } from '../../../../../components/buttons';
import Button from '../../../../../components/buttons/Button';
import { getValuesForPatch } from '../../../../../components/forms/form-util';
import { CrossIcon } from '../../../../../components/icons';

type EditPersonUtilityProps = {
  className?: string;
  initialData: PersonUtilityData;
};

const EditPersonUtility = ({ className, initialData }: EditPersonUtilityProps) => {
  const [showModal, setShowModal] = useState(false);
  const queryClient = useQueryClient();
  const patchPersonUtility = useMutation({
    mutationFn: async (data: Partial<PersonUtilityData>) =>
      apiClient.service('person-utility').patch(initialData.id, data),
    onSuccess: async (data) => {
      setShowModal(false);
      await queryClient.invalidateQueries(['person-utility', data.person_id]);
    },
    onError: defaultOnError,
  });

  const onSubmit = (formState: FormState<PersonUtilityData>) => {
    const modified = getValuesForPatch(formState);
    const {
      utility,
      company,
      person,
      ...data
    } = modified;

    data.utility_id = utility?.id ?? data.utility_id;
    data.company_id = company === null ? null : company?.id ?? data.company_id;
    data.person_id = person?.id ?? data.person_id;

    return patchPersonUtility.mutateAsync(data);
  };

  return (
    <>
      <Button onClick={() => setShowModal(true)} className={className}>Upravit</Button>
      <Modal
        isOpen={showModal}
        ariaHideApp={false}
        contentLabel="My dialog"
        className="relative bg-bg p-7 translate-1/2 rounded-lg m-auto min-w-[450px]"
        overlayClassName="bg-overlay fixed top-0 left-0 right-0 bottom-0 flex flex-col overflow-auto p-5 z-modal"
      >
        <IconButton
          style={{ position: 'absolute', top: 5, right: 5 }}
          onClick={() => setShowModal(false)}
        >
          <CrossIcon />
        </IconButton>
        <PersonUtilityForm
          title="Upravit pomůcku"
          onSubmit={onSubmit}
          initialValues={initialData}
          personId={initialData.person_id}
        >
          <div className="flex gap-4">
            <Button onClick={() => setShowModal(false)}>Zavřít</Button>
            <div className="grow" />
            <Button type="submit" disabled={patchPersonUtility.isLoading}>Uložit</Button>
          </div>
        </PersonUtilityForm>
      </Modal>
    </>
  );
};

export default EditPersonUtility;
